var map = {
	"./AD 01.jpg": 2158,
	"./AD 02.jpeg": 9678,
	"./AD 03.jpg": 2828,
	"./AD 04.jpg": 7239,
	"./AD 05.jpg": 5082,
	"./AD 06.jpg": 5573,
	"./AD 07.jpg": 4392,
	"./AD 08.jpg": 7891,
	"./AD 09.jpg": 9366,
	"./AD 10.jpg": 3068,
	"./AD 11.jpg": 8441,
	"./AD 12.jpg": 4734,
	"./AD 13.jpg": 9515,
	"./AD 14.JPG": 8647,
	"./AD 15.jpg": 9205,
	"./AD 16.jpg": 6602,
	"./AD 17.jpg": 7415,
	"./AD 18.jpg": 9700,
	"./AD 19.jpg": 7745,
	"./AD 20.jpg": 5741,
	"./AD 21.jpg": 176,
	"./AD 22.jpg": 3167,
	"./AD 23.jpg": 6786,
	"./AD 24.jpg": 8481,
	"./AD 25.jpg": 436,
	"./Ananthapuri fest  Campaign 03.jpg": 4330,
	"./Ananthapuri fest  Campaign 04.jpg": 5225,
	"./Ananthapuri fest Campaign 01.jpg": 3672,
	"./Ananthapuri fest Campaign 02.jpg": 1127,
	"./bhagya gold & diamonds inauguration 01.jpg": 3616,
	"./bhagya gold & diamonds inauguration 02.jpg": 255,
	"./event 01.jpg": 5101,
	"./event 02.jpg": 6146,
	"./event 03.jpg": 2527,
	"./event 04.jpg": 6148,
	"./event 04A.jpg": 7779,
	"./event 05.jpg": 4193,
	"./event 06.jpg": 4582,
	"./event 08.jpg": 7080,
	"./event 09.jpg": 4693,
	"./event 10.jpg": 9663,
	"./event 11.jpg": 1602,
	"./event 13.jpg": 5312,
	"./event 14.jpg": 1587,
	"./event 15.jpg": 8454,
	"./event 16.jpg": 6209,
	"./event 17.jpg": 1876,
	"./event 18.jpg": 935,
	"./event 19.jpg": 5098,
	"./event 20.jpg": 6090,
	"./fashion show winner 01.jpg": 5425,
	"./fashion show winner 02.jpg": 5078,
	"./fashion show winner 03.jpg": 1539,
	"./magazine ad 01.JPG": 4431,
	"./magazine ad 02.JPG": 8912,
	"./magazine ad 03.JPG": 9357,
	"./magazine ad 04.JPG": 854,
	"./magazine ad 05.JPG": 3395,
	"./magazine ad 06.JPG": 3348,
	"./magazine ad 07.JPG": 6193,
	"./magazine ad 08.jpg": 1175,
	"./magazine ad 09.jpg": 7338,
	"./magazine ad 10.jpg": 7920,
	"./magazine ad 11.jpg": 9165,
	"./magazine ad 12.jpg": 3586,
	"./magazine ad 13.jpg": 1647,
	"./sankarthil silks inauguration 01.jpg": 5266,
	"./sankarthil silks inauguration 02.jpg": 3069
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4694;